<template>
  <li v-if="item" class="paragraph-14-medium" :class="itemDynamicClass">
    <span v-if="item.sub && item.sub != ''" class="pricing-sub pricing-sub-instant">{{ sub }}</span>
    <span class="main-text">{{ content }}</span>
    <template v-if="item.label && item.label.text">
      <div class="d-flex align-items-start border-radius bg-accent-amber-500 py-1 pl-1 warning2 mt-4px mb-3" v-if="item.label.type == 'warning2'">
        <i class="icon icon-info txt-accent-amber-300 mr-12px"></i>
        <p class="paragraph-14-regular">
          <span>
            {{ item.label.text }}
          </span>
          <template v-if="item.label.articleLink">
            <br />
            <span>
              {{ $t("pricing.moreDetail") }}
            </span>
            <a :href="item.label.articleLink" target="_blank" class="txt-primary-300">{{ $t("pricing.thisArticle") }}</a>
          </template>
        </p>
      </div>
      <span class="ml-4px clickable tooltip" v-else-if="item.label.type == 'tooltip'">
        <i class="icon icon-info"></i>
        <div v-html="item.label.text" class="py-4px px-1 mb-1 border-radius bg-dark-blue-300 txt-light-low-contrast body-12-regular tooltip__content" :style="tooltipStyle"></div>
        <div class="mb-4px tooltip__arrow">&nbsp;</div>
      </span>
      <span class="label" :class="item.label.type" v-else>{{ $t(`${item.label.text}`) }}</span>
    </template>
  </li>
</template>

<script>
export default {
  name: "PLanPackItem",
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  computed: {
    itemDynamicClass() {
      return {
        "typo-bold highlight": this.item.highlight,
        "txt-dark-high-contrast": !this.item.highlight && !this.item.disabled,
        "text-light-disabled disabled": this.item.disabled,
        "d-flex align-items-center": this.item.label?.type == "tooltip"
      };
    },
    content() {
      return this.$t(this.item.content);
    },
    sub() {
      return this.$t(this.item.sub);
    },
    tooltipStyle() { 
      const minWidthNumber = this.item.label?.minWidth || 216
      return {
        "min-width": `${minWidthNumber}px`,
      }
    }
  }
};
</script>

<style lang="scss" scoped>
li {
  padding-left: 38px;
  position: relative;

  &:not(:first-child) {
    margin-top: 20px;
  }

  &:before {
    content: "";
    position: absolute;
    $size: 22px;
    width: $size;
    height: $size;
    top: 0;
    left: 0;
    background-image: url("data:image/svg+xml,%3Csvg width='22' height='22' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.2585 13.7183L7.77156 9.9363C7.77151 9.93625 7.77146 9.93619 7.7714 9.93613C7.41248 9.54479 6.79266 9.51077 6.39882 9.87182C6.00732 10.2307 5.97323 10.8507 6.33433 11.2446L6.33455 11.2448L10.5055 15.7749C10.6725 15.9734 10.9348 16.1022 11.2263 16.1022C11.4791 16.1022 11.7443 16.0087 11.9173 15.8051L22.4683 5.28167C22.8705 4.91033 22.8226 4.29027 22.4751 3.91116C22.1092 3.51201 21.4852 3.51892 21.0977 3.90642C21.0977 3.90643 21.0977 3.90644 21.0977 3.90646L11.2585 13.7183Z' fill='%233C67FF' stroke='%233C67FF' stroke-width='0.3'/%3E%3Cpath d='M0.85 12C0.85 18.1356 5.86438 23.15 12 23.15C18.1356 23.15 23.15 18.1356 23.15 12C23.15 11.4473 22.7235 11.0209 22.1709 11.0209C21.6182 11.0209 21.1918 11.4473 21.1918 12C21.1918 17.0579 17.0579 21.1917 12 21.1917C6.94213 21.1917 2.8083 17.0579 2.8083 12C2.8083 6.94208 6.94213 2.80824 12 2.80824C12.5527 2.80824 12.9791 2.38178 12.9791 1.82912C12.9791 1.27647 12.5527 0.85 12 0.85C5.86438 0.85 0.85 5.86443 0.85 12Z' fill='%233C67FF' stroke='%233C67FF' stroke-width='0.3'/%3E%3C/svg%3E%0A");
    background-position-x: 0;
    background-position-y: 0;
    // box-shadow: 0px 7px 15px rgba(0, 24, 46, 0.1);
  }

  &.disabled {
    &:before {
      background-image: url("data:image/svg+xml,%3Csvg width='22' height='22' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.85 12C0.85 18.1356 5.86438 23.15 12 23.15C18.1356 23.15 23.15 18.1356 23.15 12C23.15 11.4473 22.7235 11.0209 22.1709 11.0209C21.6182 11.0209 21.1918 11.4473 21.1918 12C21.1918 17.0579 17.0579 21.1917 12 21.1917C6.94213 21.1917 2.8083 17.0579 2.8083 12C2.8083 6.94208 6.94213 2.80824 12 2.80824C12.5527 2.80824 12.9791 2.38178 12.9791 1.82912C12.9791 1.27647 12.5527 0.85 12 0.85C5.86438 0.85 0.85 5.86443 0.85 12Z' fill='%239E9E9E' stroke='%239E9E9E' stroke-width='0.3'/%3E%3Cpath d='M12 0.85C5.86438 0.849999 0.85 5.86438 0.85 12C0.85 18.1356 5.86438 23.15 12 23.15C12.5527 23.15 12.9791 22.7235 12.9791 22.1709C12.9791 21.6182 12.5527 21.1918 12 21.1918C6.94213 21.1918 2.80829 17.0579 2.80829 12C2.80829 6.94213 6.94213 2.8083 12 2.8083C17.0579 2.8083 21.1918 6.94213 21.1918 12C21.1918 12.5527 21.6182 12.9791 22.1709 12.9791C22.7235 12.9791 23.15 12.5527 23.15 12C23.15 5.86438 18.1356 0.85 12 0.85Z' fill='%239E9E9E' stroke='%239E9E9E' stroke-width='0.3'/%3E%3Crect x='6' y='11' width='12' height='2' rx='1' fill='%239E9E9E' stroke='%239E9E9E' stroke-width='0.5'/%3E%3C/svg%3E%0A");
    }
    .main-text {
      text-decoration: line-through;
    }
  }
  .label {
    padding: 2px 8px;
    color: $light1;
    margin-left: 4px;
    border-radius: $radius;
    text-transform: uppercase;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    &.danger {
      background: #e8486c;
    }
    &.secondary {
      background: map-get($accent-green-new, "400");
      color: map-get($dark-text-new, "low-contrast");
    }
    &.warning {
      background: map-get($accent-amber, "400");
      color: map-get($dark-text-new, "low-contrast");
    }
  }

  .warning2 {
    margin-left: -38px;
    padding-right: 26px;
    border: 1px solid map-get($accent-amber, "300");

    .icon {
      font-size: 20px;
    }
  }

  .tooltip {
    position: relative;

    &__content {
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      display: none;
    }

    &__arrow {
      position: absolute;
      bottom: 100%;
      left: 50%;
      width: 0;
      height: 0;
      transform: translateX(-50%);
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 4px solid map-get($dark-blue, "300");
      border-bottom: 0;
      display: none;
    }

    &:hover {
      .tooltip__content, .tooltip__arrow {
        display: block;
      }
    }
  }
}
</style>
